import { EducationModule } from "@js/components/EducationCourse/eduConfig";
import { level1ModuleCompleteColor } from "@js/educationContent/CairoMummiesContent/eduConstants";
import Ribbon0 from "@js/public/images/Ribbon0.svg";
import StarklingsLogo from "@js/public/images/StarklingsLogo.svg";
import {
    lesson0DefaultEndCode,
    lesson0DefaultMiddleCode,
    lesson0DefaultStartCode,
} from "./lesson0";
import {
    lesson1DefaultEndCode,
    lesson1DefaultMiddleCode,
    lesson1DefaultStartCode,
} from "./lesson1";
import {
    lesson2DefaultEndCode,
    lesson2DefaultMiddleCode,
    lesson2DefaultStartCode,
} from "./lesson2";
import { m8l0Solution } from "./lesson0Solution";
import { m8l1Solution } from "./lesson1Solution";
import { m8l2Solution } from "./lesson2Solution";

export const starklings1OptionsConfig: EducationModule = {
    solution: "",
    imgSrc: StarklingsLogo.src,
    moduleInfo: {
        id: 8,
        moduleName: "starklings1Options",
        timeEstimate: "25-35 min",
        title: "Starklings 1.0 Options",
        description: `Welcome to the intro of Starklings 1.0 Options lessons. Good luck!`,
        moduleComplete: {
            badgeName: "STARKLINGS 1.0 OPTIONS",
            badgeCaption: "A level 1 Starkling 1.0",
            ribbonImgSrc: Ribbon0.src,
            badgeImgSrc: StarklingsLogo.src,
            imgColor: level1ModuleCompleteColor,
            badgeTokenId: 21,
        },
    },
    lessons: [
        {
            timeEstimate: "5 min",
            title: "Options00",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "Options" } ] }, { "type": "paragraph", "children": [ { "text": "Type Option represents an optional value: every Option is either Some and contains a value, or None, and does not. Option types are very common in Cairo code, as they have a number of uses:" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "Initial values" } ] }, { "type": "list-item", "children": [ { "text": "Return values for functions that are not defined over their entire input range (partial functions)" } ] }, { "type": "list-item", "children": [ { "text": "Return value for otherwise reporting simple errors, where None is returned on error" } ] }, { "type": "list-item", "children": [ { "text": "Optional struct fields" } ] }, { "type": "list-item", "children": [ { "text": "Optional function arguments" } ] } ] }, { "type": "paragraph", "children": [ { "text": "Further Information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch05-01-enums.html#the-option-enum-and-its-advantages", "children": [ { "text": "Option Implementation" } ] }, { "text": "" } ] } ] } ]
`,
            hints: [],
            defaultStartCode: lesson0DefaultStartCode,
            defaultMiddleCode: lesson0DefaultMiddleCode,
            defaultEndCode: lesson0DefaultEndCode,
            id: 0,
            solution: m8l0Solution,
        },
        {
            timeEstimate: "10 min",
            title: "Options01",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "Options" } ] }, { "type": "paragraph", "children": [ { "text": "Type Option represents an optional value: every Option is either Some and contains a value, or None, and does not. Option types are very common in Cairo code, as they have a number of uses:" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "Initial values" } ] }, { "type": "list-item", "children": [ { "text": "Return values for functions that are not defined over their entire input range (partial functions)" } ] }, { "type": "list-item", "children": [ { "text": "Return value for otherwise reporting simple errors, where None is returned on error" } ] }, { "type": "list-item", "children": [ { "text": "Optional struct fields" } ] }, { "type": "list-item", "children": [ { "text": "Optional function arguments" } ] } ] }, { "type": "paragraph", "children": [ { "text": "Further Information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch05-01-enums.html#the-option-enum-and-its-advantages", "children": [ { "text": "Option Implementation" } ] }, { "text": "" } ] } ] } ]
`,
            hints: [],
            defaultStartCode: lesson1DefaultStartCode,
            defaultEndCode: lesson1DefaultEndCode,
            defaultMiddleCode: lesson1DefaultMiddleCode,
            id: 1,
            solution: m8l1Solution,
        },
        {
            timeEstimate: "15 min",
            title: "Options02",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "Options" } ] }, { "type": "paragraph", "children": [ { "text": "Type Option represents an optional value: every Option is either Some and contains a value, or None, and does not. Option types are very common in Cairo code, as they have a number of uses:" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "Initial values" } ] }, { "type": "list-item", "children": [ { "text": "Return values for functions that are not defined over their entire input range (partial functions)" } ] }, { "type": "list-item", "children": [ { "text": "Return value for otherwise reporting simple errors, where None is returned on error" } ] }, { "type": "list-item", "children": [ { "text": "Optional struct fields" } ] }, { "type": "list-item", "children": [ { "text": "Optional function arguments" } ] } ] }, { "type": "paragraph", "children": [ { "text": "Further Information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch05-01-enums.html#the-option-enum-and-its-advantages", "children": [ { "text": "Option Implementation" } ] }, { "text": "" } ] } ] } ]
`,
            hints: [],
            defaultStartCode: lesson2DefaultStartCode,
            defaultEndCode: lesson2DefaultEndCode,
            defaultMiddleCode: lesson2DefaultMiddleCode,
            id: 2,
            solution: m8l2Solution,
        },
    ],
};
